import * as $          from 'jquery';
import { onLoad }     from 'Core/Events';
import {$body} from "Core/Body";
import {Decimal} from "decimal.js";

export const GoogleDataLayerDynamicEvents = (() => {

    const Selector = {
        ADD_TO_CART:           '.js_google_data_layer_add_to_cart',
        QUANTITY:              '.js_product_page_quantity'
    };

    function googleDataLayerEventAddToCart(e)
    {
        if (!window.dataLayer) return;

        let btn = $(e.target);
        let quantity = $(Selector.QUANTITY).val() as number || 1;
        let price = new Decimal(btn.data('fb-price') * quantity ).toFixed(2);

        let gdlComponentData = {
            items : [{
                item_id : btn.data('gdl-id'),
                item_name : btn.data('gdl-name'),
                item_brand : btn.data('gdl-brand'),
                item_category : btn.data('gdl-category'),
                quantity : quantity,
                price : price
            }],
            currency: btn.data('gdl-currency'),
            value : price
        }

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: gdlComponentData
        });

    }

    $body.on("click", Selector.ADD_TO_CART, googleDataLayerEventAddToCart);

    return true;
})();
import * as $          from 'jquery';
import { onLoad }     from 'Core/Events';
import {$body} from "Core/Body";
import {Decimal} from "decimal.js";

export const GoogleDataLayerDynamicEvents = (() => {

    const Selector = {
        ADD_TO_CART:           '.js_google_data_layer_add_to_cart',
        QUANTITY:              '.js_product_page_quantity'
    };

    function googleDataLayerEventAddToCart(e)
    {
        if (!window.dataLayer) return;

        let btn = $(e.target);
        let quantity = $(Selector.QUANTITY).val() as number || 1;
        let price = new Decimal(btn.data('fb-price') * quantity ).toFixed(2);

        let gdlComponentData = {
            items : [{
                item_id : btn.data('gdl-id'),
                item_name : btn.data('gdl-name'),
                item_brand : btn.data('gdl-brand'),
                item_category : btn.data('gdl-category'),
                quantity : quantity,
                price : price
            }],
            currency: btn.data('gdl-currency'),
            value : price
        }

        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: gdlComponentData
        });

    }

    $body.on("click", Selector.ADD_TO_CART, googleDataLayerEventAddToCart);

    return true;
})();
